import $ from 'jquery';
 
import { View } from 'backbone'; 
import notificationService from 'NotificationService';
import template from 'common-views/add-asset-template.ejs';
import restServiceAux from 'RestServiceAux';
import restMessages from 'RestMessages';
import assetCollection from 'AssetCollection';
import AssetModel from 'AssetModel';
import eventBus         from 'EventBus';
import listService      from 'ListService';
import constValues from 'Constants.js';
import util             from 'util/Util.js';

class AddAssetView extends View {
    initialize( opts ) {
        this.options = opts || {};
        
        this.listenTo(this.model, 'change', this.render);

        this.allowedMimeTypes = {
            'image/jpeg': true,
            'image/jpg': true,
            'image/gif': true,
            'image/png': true,
            'video/x-flv': true,
            'audio/mp3': true
        };

        return this;
    }

    loadAssetViewer(input) {
        if (this.validateFile($('#file-asset')[0].files[0])) {  
            $('#assetViewerContainer').css('display', 'table-cell');
            var reader = new FileReader();

            reader.onload = function (e) {
                $('#assetViewer')
                    .attr('src', e.target.result);
            };

            $('#file-asset-label').prop('for', '').addClass('btn-disabled');
            $('.btn-addAssetBack').removeClass('btn-disabled'); 
            $('#file-asset-name').prop('disabled', false);

            reader.readAsDataURL($('#file-asset')[0].files[0]);
        }
    }

    validateFile(file) {
        let errorMsg = $('.error_message'); 
            this.file = file;

            if (!this.file) {
                errorMsg.text('No file selected, please select a file') 
                        .removeClass('hide');
                return false;
            }

            if (!this.fileIsAllowed(this.file)) {
                errorMsg.text('Wrong file type, please correct')
                        .removeClass('hide');
                return false;
            } 

            let assetFound = assetCollection.models.find(asset => 
                asset.get('tmpName') === this.file.name.substr(0, this.file.name.lastIndexOf('.')) && 
                        asset.get('mimeType') === this.file.type
            );

            if (assetFound) {
                const app = listService.mainKind === constValues.KIND_LAYOUT ? 'app' : 'report';
                errorMsg.text('Asset already exists in the ' + app +' by the name ' + this.file.name)
                        .removeClass('hide');
                return false;
            }

            errorMsg.text('').addClass('hide');

            return true; 
    } 

    fileIsAllowed(file){
        return this.allowedMimeTypes[file.type];
    }

    addAssetToServer(name, type, mimeType) {
        const fileContents = $('#file-asset')[0].files[0];

        const newAsset = new AssetModel();

        newAsset.set('name', name + '.' + this.fileExt, {silent:true});
        newAsset.set('type', type, {silent:true});
        newAsset.set('mimeType', fileContents.type, {silent:true});

        const formId = listService.currentForm.model.get('id');

        restServiceAux.addAsset(fileContents, formId, newAsset, '', this.processResult);
    }

    processResult(error, data, newAsset) {
        if (error) {
            console.log('processResult', error);
            notificationService.error(error);
        } else {
            // Insert the new Asset Info into the Form Collection
            newAsset.set('assetId', data.RESULT.RESPONSE.AssetId);
            newAsset.set('id', data.RESULT.RESPONSE.AssetId);

            assetCollection.add(newAsset);
            eventBus.trigger('assetAdded');

            $('#common-carousel div').removeClass('active'); 
            $('#common-carousel div:last-child').addClass('active'); 
            $('#'+data.RESULT.RESPONSE.AssetId).click();

            notificationService.success('Image Saved Successfully');
            $( '#dialog-form' ).dialog("close");
        }
    }

    render() {
        this.$el.html(template(this.model.toJSON()));
        $('body').append(this.$el); 

        var self = this;
        // Show modal popup window
        const dialog = $( '#dialog-form' ).dialog({
            dialogClass: "no-close",
            autoOpen: true,
            height: 'auto',
            width: 500,
            modal: true,
            resizable: false,
            position: { my: "top", at: "top", of: $('#editor-content') },
            buttons: [
                {
                    text: 'OK',
                    'class':'btn-addAssetBack btn-disabled',
                    click: function() {
                        if (!$('.btn-addAssetBack').hasClass('btn-disabled')) {
                            $('.btn-addAssetBack').addClass('btn-disabled'); 
                            $('.btn-addAssetCancel').addClass('btn-disabled'); 
                            
                            let filename = $('#file-asset').val();
                            let name = $('#file-asset-name').val();
                            let type = 'image';
                            self.addAssetToServer(name, type);
                            util.enableSaveOption();
                            listService.setDirty(true);
                        }
                    }
                },
                {
                    text: 'Cancel',
                    'class':'btn-addAssetCancel',
                    click: function() {
                        if (!$('.btn-addAssetCancel').hasClass('btn-disabled')) {
                            dialog.dialog( "close" );
                        }
                    }
                }
            ],
            close: function() {
                dialog.dialog("destroy");
                $( '#dialog-form').remove();
            }
        });

        $('#file-asset').change(function(e) {
            let fileName = e.target.value.split( '\\' ).pop(); 
            self.fileExt = fileName.lastIndexOf(".");
            $('#file-asset-name').val(fileName.substr(0, fileName.lastIndexOf(".")));
            self.loadAssetViewer(null);
        });

        $('.close-icon-asset').click((e) => {
            e.stopPropagation();
            e.preventDefault();

            $('#file-asset-label').prop('for', 'file-asset').removeClass('btn-disabled');
            $('.btn-addAssetBack').addClass('btn-disabled'); 
            $('#file-asset-name').val('').prop('disabled', true); 
            $('#assetViewer').attr('src', '');
            $('#file-asset').val('');
            $('#assetViewerContainer').css('display', 'none');
            $('#asset-error-msg').addClass('hide');
        });
  
        return this;
    }
}
export default AddAssetView;